module.exports = __webpack_public_path__ + "static/media/for-ever.01844235.jpg";